import React, { useState, useEffect } from 'react';
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    Box, 
    Typography,
    Chip
} from '@mui/material';
import { Schedule } from '@mui/icons-material';

/**
 * TimezoneSelector component
 * 
 * Biedt een dropdown om tijdzone te selecteren
 * Slaat de tijdzonevoorkeur op in localStorage
 * Default: Europe/Amsterdam (CET)
 */
const TimezoneSelector = ({ value, onChange }) => {
    const timezones = [
        { value: 'Europe/Amsterdam', label: 'Amsterdam (CET/CEST)', country: '🇳🇱' },
        { value: 'Europe/London', label: 'London (GMT/BST)', country: '🇬🇧' },
        { value: 'Europe/Berlin', label: 'Berlin (CET/CEST)', country: '🇩🇪' },
        { value: 'Europe/Paris', label: 'Paris (CET/CEST)', country: '🇫🇷' },
        { value: 'America/New_York', label: 'New York (EST/EDT)', country: '🇺🇸' },
        { value: 'America/Los_Angeles', label: 'Los Angeles (PST/PDT)', country: '🇺🇸' },
        { value: 'Asia/Tokyo', label: 'Tokyo (JST)', country: '🇯🇵' },
        { value: 'UTC', label: 'UTC (Coordinated Universal Time)', country: '🌍' }
    ];

    const selectedTimezone = timezones.find(tz => tz.value === value);

    return (
        <Box>
            <FormControl fullWidth margin="normal">
                <InputLabel id="timezone-select-label">Tijdzone</InputLabel>
                <Select
                    labelId="timezone-select-label"
                    value={value}
                    label="Tijdzone"
                    onChange={(e) => onChange(e.target.value)}
                    renderValue={(selected) => {
                        const timezone = timezones.find(tz => tz.value === selected);
                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{timezone?.country}</span>
                                <span>{timezone?.label}</span>
                            </Box>
                        );
                    }}
                >
                    {timezones.map((timezone) => (
                        <MenuItem key={timezone.value} value={timezone.value}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <span>{timezone.country}</span>
                                <span>{timezone.label}</span>
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            
            {selectedTimezone && (
                <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Schedule sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                    <Typography variant="caption" color="text.secondary">
                        Huidige tijd: {new Date().toLocaleString('nl-NL', { 
                            timeZone: selectedTimezone.value,
                            day: '2-digit',
                            month: '2-digit', 
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default TimezoneSelector; 